import React from "react";
import Importcompo from "../components/Importcompo";

function Import() {
  return (
    <div>
      <Importcompo title="Import" />
    </div>
  );
}

export default Import;
